import { render, staticRenderFns } from "./CheckComponent.vue?vue&type=template&id=00d15da2&"
import script from "./CheckComponent.vue?vue&type=script&lang=ts&"
export * from "./CheckComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports